<template>
  <div class="p-4 space-y-4">
    <div class="flex justify-start"> <span class="text-sm ">&#60; IngresoPresupuestos&#62;</span></div>

    <h1 class=" text-gray-700 mb-2">{{ centro.nombre }}</h1>
   

<!--     <div v-if="accionModifPresup">
      
       <CuentaPresupuestos :cuenta="cuentamodif" :centro="centro" :cuentaExpandida="cuentaExpandida"
            @toggleCuenta="toggleCuenta" @exit="exit"></CuentaPresupuestos>

    </div> 
    
     v-else 
     -->
    

    <!-- Nivel 1: Categorías -->
    <div v-for="categoria in this.categorias" :key="categoria.id" class="border rounded-lg bg-gray-100 p-3 mt-3">
      <h2 class="  text-gray-700 mb-2">
      {{ categoria.nombre }}  
      </h2>
    
      <!-- Nivel 2: Tipos -->
      <div v-for="tipo in categoria.tipos" :key="tipo.id" class="ml-1 border-l-4 border-blue-300 pl-0 mb-3">

        <h3 class="text-md  text-blue-700 mb-1">{{ tipo.nombre }}</h3>

        <!-- Nivel 3: Cuentas -->
        <div v-for="cuenta in tipo.cuentas" :key="cuenta.id" class="ml-1">
       <!--  {{ cuenta }}  -->   
          <CuentaPresupuestos :cuenta="cuenta" :centro="centro" :cuentaExpandida="cuentaExpandida"
            @toggleCuenta="toggleCuenta" @exit="exit"></CuentaPresupuestos>

        </div>
      </div>
    </div>
  </div>
</template>


<script>

import CuentaPresupuestos from "./CuentaPresupuestos.vue";
export default {
  name: 'MaestroCentros',
  props: {
    centro: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      valor: '',
      listado: {},
      categorias: {},
      tipos: {},
      cuentaExpandida: [], // almacena IDs de cuentas abiertas
      accionModifPresup:0, 
      cuentamodif: 0
    }
  },
  methods: {

    toggleCuenta(id) {
      const i = this.cuentaExpandida.indexOf(id);
      if (i === -1) {

        this.cuentaExpandida.push(id);
        this.$store.dispatch("cuentaUpdVisible", { id: id, centro: this.centro.id, visible: true });
        // store showCta
      } else {
        console.log(i)
        this.cuentaExpandida.splice(i, 1);
        this.$store.dispatch("cuentaUpdVisible", { id: id, centro: this.centro.id, visible: false });
      }
    },
    exit(v){
      console.log('exit',v);
      this.accionModifPresup=v;
    },
    async categoriasAgrupadas() {
      // Agrupa por categoría y tipo


      this.listado = this.$store.state.cuentas.cuentas;
      this.listado.forEach((cuenta) => {
        const cat = cuenta.tipo_cuenta.categoria_cuenta;
        const tip = cuenta.tipo_cuenta;
        const codigocta = cuenta.codigo;
        const idcta = cuenta.id;
        const nomcta = cuenta.nombre;
        const total_presupuesto = '';
        /*  
         {
           .id
           .codigo
           .nombre
           +tipo_cuenta{
             .id
             .nombre
             +categoria_cuenta{  // cat
               .id
               .nombre
             }
           }
         }  
         */

        if (!this.categorias[cat.id]) {
          this.categorias[cat.id] = {
            id: cat.id,
            nombre: cat.nombre,
            tipos: []
          };

        }
        // busca tipos 
        let tipos = this.categorias[cat.id].tipos;
        let existeTipo = tipos.find(tipo => tipo.id === tip.id);
        if (typeof existeTipo == 'undefined') {
          tipos.push({ 'id': tip.id, 'nombre': tip.nombre, 'cuentas': [{ 'id': idcta, 'cod': codigocta, 'nomcta': nomcta,'total_presupuesto':total_presupuesto  }] })
          this.categorias[cat.id].tipos = tipos;
        } else {


          existeTipo.cuentas.push({ 'id': idcta, 'cod': codigocta, 'nomcta': nomcta,'total_presupuesto':total_presupuesto  })
          this.categorias[cat.id].tipos.cuentas = existeTipo;

        }




        /*
                   //-- categorias
                   {
                     .id
                     .nombre
                     +tipos:{
                       .id
                       .nombre
                       +cuentas{
                         .id
                         .codigo
                         .nombre
                       }
                     }
                   }
                 */



      });

      this.categorias = Object.values(this.categorias).sort((a, b) =>
        a.nombre.localeCompare(b.nombre)
      );
      this.categorias.forEach(cat => {
        if (Array.isArray(cat.tipos)) {
          cat.tipos.sort((a, b) => a.nombre.localeCompare(b.nombre));
        }
      });



      console.log(this.categorias)
    }
  },
  mounted() {
    let obj = this.$store.state.centrocuentas.visibilidad;

    const filtrados = obj.filter(item => item.centro === this.centro.id);
    filtrados.forEach(element => {
      if (element.visible) {
        const id = element.id;

        this.cuentaExpandida.push(id);
      }
    });

    this.categoriasAgrupadas()


  },
  components: {

    CuentaPresupuestos
  },
  watch: {
    cuenta_id: function (value) {
      console.log('montando', value)
    },
    centro_id: function (value) {
      console.log('montando', value, this.centro_id)
    },
    accionModifPresup: function(v){
        if(v){ 
            console.log('hola')
            this.cuentamodif=   this.categorias
                                .flatMap(item => item.tipos)         // aplana tipos
                                .flatMap(tipo => tipo.cuentas)       // aplana cuentas
                                .find(cuenta => cuenta.id === v.cuenta_id);
             this.$store.dispatch("cuentaUpdVisible", { id: v.cuenta_id, centro:v.centro_id, visible: false });
             const index = this.cuentaExpandida.indexOf(v.cuenta_id);
              if (index !== -1) {
                this.cuentaExpandida.splice(index, 1);
              }
            }
    }
  }

}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>